import Image from 'components/shared/image/image';
import RichText from 'components/shared/richtext';
import useIsMobile from 'hooks/utils/useIsMobile';
import cn from 'classnames';
import styles from './contact.module.scss';

const ContactInfo = ({ data, showHeader = false, hideContact = false }) => {
  const {
    title,
    subtitle,
    heroImage,
    infoTitle,
    infoBody,
    consumerTitle,
    consumerPhone,
    salonsTitle,
    salonsPhone,
    salonsEmail,
    addressTitle,
    addressText,
    secondaryImage,
    email,
  } = data;
  const trimPhoneNumber = string => string?.match(/(\d[\s\S]*)/)?.[1]?.trim();

  const isMobile = useIsMobile();
  const strippedConsumerPhone = `+${trimPhoneNumber(consumerPhone)}`;
  const strippedAddressPhone = `+${trimPhoneNumber(salonsPhone)}`;

  return (
    <section
      id="sectionContact"
      className={cn({
        [styles.hidden]: hideContact,
      })}
    >
      <section className={styles.section}>
        {showHeader && (
          <div className={styles.contactHeader}>
            <h1 className={styles.title}>{title}</h1>
            <h3 className={styles.subtitle}>{subtitle}</h3>
          </div>
        )}
        <div className={styles.customerSupport}>
          <div className={styles.heroImage}>
            <Image src={heroImage} layout="fill" loading="lazy" />
          </div>
          <div className={styles.customerSection}>
            <h2 className={styles.infoTitle}>{infoTitle}</h2>
            {infoBody && <RichText className={styles.infoBody} text={infoBody.json} />}
            <h2 className={styles.consumerTitle}>{consumerTitle}</h2>
            <a href={`tel: +${strippedConsumerPhone}`} className={styles.consumerPhone}>
              {consumerPhone}
            </a>
            {isMobile && (
              <span className={styles.consumerEmail}>
                {email}
                <a href={`mailto: ${salonsEmail}`} className={styles.email}>
                  {salonsEmail}
                </a>
              </span>
            )}
            <h2 className={styles.salonsTitle}>{salonsTitle}</h2>
            <a href={`tel: +${strippedAddressPhone}`} className={styles.salonsPhone}>
              {salonsPhone}
            </a>
            {isMobile && (
              <span className={styles.salonsEmail}>
                {email}
                <a href={`mailto: ${salonsEmail}`} className={styles.email}>
                  {salonsEmail}
                </a>
              </span>
            )}
          </div>
        </div>
      </section>
      <section className={styles.headQuartersSection}>
        <div className={styles.secondImage}>
          <Image src={secondaryImage} layout="fill" loading="lazy" />
        </div>
        <div className={styles.headQuarterInfo}>
          <h2 className={styles.addressTitle}>{addressTitle}</h2>
          <RichText className={styles.addressInfo} text={addressText?.json} />
          <div className={styles.socials}>
            <a href={`tel: ${strippedAddressPhone}`} className={styles.addressPhone}>
              {salonsPhone}
            </a>
            <span className={styles.addressEmail}>
              {email}
              <a href={`mailto: ${salonsEmail}`} className={styles.email}>
                {salonsEmail}
              </a>
            </span>
          </div>
        </div>
      </section>
    </section>
  );
};

export default ContactInfo;
